import {
  formatCurrency,
  formatDateOnly,
  NEED_STAGE_LABELS,
  type NeedQuoteSummary,
  type NeedStage,
} from '@peles/shared';

/** The `StatusBadge` colour of each stage, from nothing yet to done. */
export const NEED_STAGE_COLORS: Record<NeedStage, string> = {
  NEW: 'gray',
  REQUESTED: 'yellow',
  SOURCING: 'blue',
  BOOKED: 'purple',
  PAID: 'green',
};

export function stageLabel(stage: NeedStage): string {
  return NEED_STAGE_LABELS[stage];
}

/** "Oct 12" — a stored `YYYY-MM-DD` read as the day it names. */
export function shortDay(day: string | null | undefined): string {
  return day ? formatDateOnly(day, { month: 'short', day: 'numeric' }) : '';
}

/**
 * A need's quotes in one line: "3 quotes · $4,300 – $6,100", or while none is
 * back "2 asked · 0 back". Empty when nothing has been asked.
 */
export function describeQuotes(q: NeedQuoteSummary): string {
  if (q.asked === 0) return '';
  if (q.back === 0) return `${q.asked} asked · 0 back`;
  const money = (n: number) => formatCurrency(n, { wholeDollars: true });
  const spread =
    q.lowest !== null && q.highest !== null && q.lowest !== q.highest
      ? `${money(q.lowest)} – ${money(q.highest)}`
      : q.lowest !== null
        ? money(q.lowest)
        : '';
  const count = `${q.back} ${q.back === 1 ? 'quote' : 'quotes'}`;
  const waiting = q.asked > q.back ? ` · ${q.asked - q.back} waiting` : '';
  return `${count}${spread ? ` · ${spread}` : ''}${waiting}`;
}
